var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "last_version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "07_BUSQUEDA_TELEFONOS_CLIENTE",
    transform: "translate(-590.000000, -178.000000)",
    fill: "#B0B0B0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(590.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25,9.96428571 C11.8723092,9.96428571 9.96428571,11.9016634 9.96428571,14.25 C9.96428571,16.6276908 11.9016634,18.5357143 14.25,18.5357143 C16.6276908,18.5357143 18.5357143,16.5983366 18.5357143,14.25 C18.5357143,11.9016634 16.6276908,9.96428571 14.25,9.96428571 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0535714,0.321428571 C6.91610443,0.321428571 0.321428571,6.91610443 0.321428571,15.0535714 C0.321428571,23.1910384 6.91610443,29.7857143 15.0535714,29.7857143 C23.1910384,29.7857143 29.7857143,23.1910384 29.7857143,15.0535714 C29.7857143,6.91610443 23.1910384,0.321428571 15.0535714,0.321428571 Z M22.2230126,22.6162731 C22.011257,22.8280287 21.6784981,22.949032 21.3154884,22.949032 C21.3154884,22.949032 21.3154884,22.949032 21.3154884,22.949032 C20.9524787,22.949032 20.6499707,22.8280287 20.4079642,22.6162731 L17.62489,19.8331989 L17.3526327,19.9844529 C16.3543561,20.5289674 15.2653271,20.8314755 14.1460472,20.8314755 C10.4856996,20.8314755 7.52112056,17.8668965 7.52112056,14.2065488 C7.52112056,10.5462012 10.4856996,7.58162218 14.1460472,7.58162218 C17.8063948,7.58162218 20.7709739,10.5462012 20.7709739,14.2065488 C20.7709739,15.5073335 20.4079642,16.7476166 19.6819449,17.8366456 L19.50044,18.1391537 L22.2532634,20.8919771 C22.4650191,21.1339836 22.6162731,21.4364916 22.6162731,21.7692505 C22.5860223,22.0717586 22.4650191,22.3742666 22.2230126,22.6162731 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5127d7ddc3bc75f60e9288a87236a39a.svg";
export { ForwardRef as ReactComponent };